import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";
import type { ServiceCardProps } from "@/types/models";

export function ServiceCard({ service, index = 0 }: ServiceCardProps) {
  const Icon = service.icon;

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
    >
      <Link
        to={service.link}
        className="card-default block h-full p-8 group focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-oceanBlue focus-visible:ring-offset-2 rounded-xl"
      >
        <div
          className={cn(
            "w-14 h-14 rounded-xl flex items-center justify-center mb-5 group-hover:scale-110 transition-transform duration-300",
            service.color
          )}
        >
          <Icon size={28} aria-hidden="true" />
        </div>

        <h3 className="font-playfair text-xl font-bold text-deepOcean mb-3">
          {service.title}
        </h3>

        <p className="text-textBody/70 text-sm leading-relaxed mb-5">
          {service.description}
        </p>

        <span className="inline-flex items-center gap-1 text-oceanBlue text-sm font-medium group-hover:gap-2 transition-all">
          Saber mais <ArrowRight size={16} aria-hidden="true" />
        </span>
      </Link>
    </motion.div>
  );
}

export default ServiceCard;
